module.exports = __webpack_public_path__ + "assets/img/gold-tooth.34083f73.png";